module.exports = __webpack_public_path__ + "static/media/26UNRWA1.8960ada3.jpg";